import { useQuery } from '@tanstack/react-query';

import { configs, constants } from '@hero/configs';
import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey } from '@hero/utils';

import * as cmsServices from '../../services';

export const useGetPublicEntities = ({ params = {}, options = {} } = {}) => {
  return useQuery(
    createQueryKey(QUERY_KEYS.useGetPublicEntitiesKey, params),
    () => cmsServices.getPublicEntities(params),
    {
      ...options,
      select: data => {
        const constantsData = data?.docs.find(d => d.key === 'config-constants-dashboard');
        const variablesData = data?.docs.find(d => d.key === 'config-variables-dashboard');
        const variables = {
          primitives: variablesData.value?.primitives,
          semantics: variablesData.value?.semantics
        };

        const appData = data?.docs.find(d => d.key === 'config-app-dashboard');
        const appConfigs = appData?.value;

        Object.assign(configs, appConfigs);
        Object.assign(constants, constantsData?.value);

        const widgetsData = data?.docs.find(d => d.key === 'config-widgets-dashboard');
        const typographyData = data?.docs.find(d => d.key === 'config-typography-dashboard');

        return {
          widgets: widgetsData?.value,
          typography: typographyData?.value,
          images: constantsData?.value?.images,
          variables
        };
      }
    }
  );
};
